import React from "react";
import PolygonBox from "../../../components/questionBoxs/PolygonBox";
import RoundedBox from "../../../components/questionBoxs/RoundedBox";
import RoundBox from "../../../components/questionBoxs/RoundBox";

function QuestionButton({ type, number,active }) {
  const componentMap = {
    notVisited: <RoundedBox border={active&&'2px solid black'} number={number} width={40} />,
    // active: <RoundedBox  color={'#3498db'} textColor={'white'} number={number} width={40} />,
    notAnswered: <PolygonBox border={active&&'2px solid black'} number={number} width={40} />,
    attempted: <PolygonBox border={active&&'2px solid black'} number={number} color="green" width={40} />,
    marked: <RoundBox border={active&&'2px solid black'} number={number} width={40} height={40} />,
    markedWithAnswered: <RoundBox border={active&&'2px solid black'} number={number} showIcon={true} width={40} height={40} />,
  };

  return componentMap[type] || <RoundedBox number={number} />;
}

export default QuestionButton;
